export const fa = {
    //home page
    downloadResume: "دانلود رزومه",
    loadMoreProducts: "محصولات بیشتر",
    readMoreReviews: "نظرات بیشتر",
    moreAboutUs: "اطلاعات بیشتر درباره ما",
    Result: `دستیابی به نتایج با`,
    Digital: "دیجیتال",
    Solution: `راهکارهای `,
    provide: "ما راه حل های خلاقانه و فنی را برای کسب و کارها ارائه می دهیم تا از طریق کانال های دیجیتال با مخاطبان هدف خود درگیر شوند",
    ourServices: "خدمات ما",
    ServicesText: `
        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
        `,
    TopProducts: `
        محصولات برتر `,
    CustomerFeedback: "بازخورد مشتریان",
    CustomerText: `
        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ است.این متن به منظور پر کردن فضای خالی استفاده می‌شود.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است...
        `,
    role: `
        نام.نقش `,
    textAboutUs: "شرکت پیشگامان مبتکر زمرد شرق با شماره ثبت 5288 در شهرستان شاهرود در سال 1397 کار خود را آغاز کرد که موسسان این شرکت با بیش از ده سال سابقه در زمینه برنامه نویسی و محیط استارتاپی کشور با استفاده از تجربیات خود و دیگران ، شروع به تأسیس کردند. آنها شرکت کردند.",
    OurProcess: "فرآیند ما",
    OurTrustedPartner: "مشتریان ما",
    Explore: "ایده های کسب و کار خود را با استراتژی های مدرن ما کشف کنید",
    team: "تیم ما آماده است تا با استراتژی های دیجیتال مارکتینگ خلاقانه و مدرن به شما در دستیابی به اهداف تجاری خود کمک کند.",
    Certification: "گواهینامه",
    Description: "توضیحات",
    Blogs: "بلاگ ها",
    Marketing: "مارکتینگ",
    readMore: `
        بیشتر بخوانید `,
    //header
    Home: "صفحه اصلی",
    Products: "محصولات",
    Projects: "پروژه ها",
    AboutUs: "درباره ما",
    ContactUs: "ارتباط با ما",
    ChangeLang: "تغییر زبان به",
    Farsi: "English",
    SwitchMode: "تغییر پس زمینه به",
    darkMode: "دارک مود",
    lightMode: "لایت مود",
    lng: "En",
    //footer
    footerText: "شرکت پیشگامان حرکت زمرد شرق با شماره ثبت 5288 در شهرستان شاهرود کار خود را در سال 1397 آغاز کرد.",

    QuickLinks: "دسترسی سریع",

    Support: "ارتباط",
    Certification: "گواهینامه",
    allJob: "فرصت شغلی",
    Address: "آدرس",
    //about us page
    aboutTitle: "شرکت پیشگامان مبتکر زمرد شرق",
    aboutDescription: "در شرکت پیشگامان مبتکر زمرد شرق، ما به قدرت بازاریابی دیجیتال ایمان داریم و به شما کمک می‌کنیم تا برند خود را با استفاده از استراتژی‌های نوین به اوج برسانید. از زمان تأسیس ما در سال 2019، هدف ما ارائه راه‌حل‌های نوآورانه و مؤثر در دنیای دیجیتال بوده است. با تیمی از کارشناسان و تجربیات موفق در زمینه‌های مختلف، به شما کمک می‌کنیم تا در فضای آنلاین برجسته شوید.",
    OurMission: "ماموریت ما",
    OurMissionDescription: "ماموریت ما ارتقای برندها و کسب‌وکارها از طریق استراتژی‌های نوین و خلاقانه است.ما به شما کمک می‌کنیم تا اهداف کسب‌وکار خود را با استفاده از فناوری و نوآوری‌های دیجیتال محقق کنید.",
    companyVision: "چشم‌انداز شرکت",
    companyVisionDescription: "در حال حاضر، برنامه شرکت بر توسعه محصولات خارجی (برنامه‌ها و وب‌سایت‌ها) و تمرکز بر حوزه‌های هوش مصنوعی و انجام پروژه‌های اتوماسیون داخلی متمرکز است.",
    Awards: "جوایز و افتخارات",
    AwardsDescription2018: "نامزد نهایی بهترین اپلیکیشن در جشنواره ایران اپ و موبایل در سال 2018",
    AwardsDescription1400: "کاندیدای نهایی طرح برتر جشنواره استان آپ کشوری در سال 1400",
    //detailBlog
    name: "نام",
    role: "نقش",
    data: "6 مهر 1403",
    Introduction: "مقدمه",

    detailDescription: "بازاریابی دیجیتال شامل چه بخش هایی است؟",
    relatedPosts: "پست های مرتبط",
    //Job
    JobOpportunities: "فرصت شغلی",
    designer: "طراح رابط و تجربه کاربری",
    ago: "2 روز پیش",
    JobText: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
    open: "باز است",
    pending: "معلق است",
    closed: "بسته است",
    //product
    uiUxDesign: "همه",
    uiUxDesign1: "طراحی ui ux",
    uiUxDesign2: "توسعه دهنده وب",
    uiUxDesign3: "توسعه دهنده موبایل",
    irangardi: "ایرانگردی",
    moreInformation: "اطلاعات بیشتر",
    productText: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. ",
    Load: "بارگیری شغل بیشتر",
    loadMoreProjects: "بارگیری پروژه بیشتر",

    //detail product
    gallery: "گالری محصولات",
    journey: `
        سفری بصری به دنیای زیبایی تجربه دیجیتال `,
    irangardiText1: "description",
    Introduction: "معرفی محصول",
    irangardiDescription: "sub description",
    TopFeatures: "ویژگی های برتر",
    ShowWeather: "نمایش شرایط آب و هوایی",
    irangardiText4: "این پلتفرم اطلاعات دقیقی در مورد وضعیت آب و هوای مکان های انتخاب شده در اختیار کاربران قرار می دهد تا بتوانند سفر خود را بهتر برنامه ریزی کنند",
    BackpackManagement: "مدیریت کوله پشتی",
    irangardiText3: "کاربران می توانند لیست تجهیزات و تجهیزات خود را برای هر فعالیت اضافه کنند تا هنگام آماده شدن برای سفر همه چیز را با خود داشته باشند",
    InteractiveMap: "نقشه تعاملی",
    irangardiText5: "کاربران می توانند مکان های طبیعی را با جزئیات از طریق نقشه های تعاملی مشاهده کنند و مسیرهای دسترسی به آنها را برنامه ریزی کنند",
    TechnicalDetails: "جزئیات فنی",
    OtherFeatures: " سایر ویژگی ها",
    Discovering: "کشف مناظر طبیعی",
    irangardiText6: "کاربران می توانند مکان های طبیعی و بکر را جستجو کنند. این بخش به کاربران این امکان را می دهد تا مکان های ایده آل خود را با استفاده از فیلترهای مختلف مانند نوع فعالیت (پیاده روی، کوه نوردی و غیره)، سختی مسیر، موقعیت جغرافیایی و فصل سفر پیدا کنند",
    Comprehensive: "اطلاعات جامع",
    irangardiText7: "برای هر مکان، اطلاعات جامع و کاملی از جمله توضیحات مسیر، شرایط آب و هوایی، عکس های واقعی کاربران و سایر نظرات طبیعت گرا ارائه شده است",
    Choose: "فعالیت های مورد علاقه خود را انتخاب کنید",
    Product: "",
    visitWebsite: "بازدید از وب سایت",
    take: "نگاهی به زیبایی های سفر به ایران! اکنون از وب سایت ما دیدن کنید!",
    Discover: "با دانلود اپلیکیشن ایرانگردی دنیای زیبایی را کشف کنید",
    irangardiText8: "کاربران می توانند بر اساس علایق خود مکان های مناسب مانند پیاده روی، کوه نوردی، دوچرخه سواری و غیره را جستجو و انتخاب کنند",
    downloadApplication: "دانلود برنامه",
    //jobDes
    JobDescription: "توضیحات شغل",
    palaseHolderName: "نام خود را وارد کنید",
    palaseHolderFamily: " نام خانوادگی خود را وارد کنید",
    palaseHolderEmail: "ایمیل خود را وارد کنید",
    palaseHolderPhone: "شماره تلفن خود را وارد کنید",
    labelName: "نام",
    labelLastName: "نام خانوادگی",
    labelEmail: "ایمیل",
    labelNumber: "شماره تلفن",
    send: "ارسال",
    CV: "بارگذاری رزومه",
    Upload: "بارگذاری فایل",
    Max: "حداکثر اندازه فایل 30 مگابایت!",
    send: "ارسال",
    sending: "درحال ارسال...",

    //contact page
    Message: "پیام شما",
    Message2: "پیام خود را وارد کنید",
    address: "ارتباط از طریق موقعیت مکانی",
    email: "ارتباط از طریق ایمیل",
    phone: "ارتباط از طریق تماس تلفنی",
    whatsapp: "ارتباط از طریق واتساپ",
    phoneNumber: "9223752649+",
    phoneRequired: "لطفاً شماره تلفن را وارد کنید",
    phoneInvalid: "شماره تلفن وارد شده معتبر نیست",
    emailRequired: "لطفاً ایمیل را وارد کنید",
    emailInvalid: "فرمت ایمیل نادرست است",
    nameRequired: "لطفاً نام خود را وارد کنید",
    lastNameRequired: "لطفاً نام خانوادگی خود را وارد کنید",
    textRequired: "لطفاً  متن را وارد کنید",
    fileRequired: "لطفاً فایل را انتخاب کنید",
    Loading: "در حال بارگذاری...",
    SuccessMessage: "اطلاعات با موفقیت ثبت شد",
    errorMessage: " خطایی رخ داده است",
    errorServerMessage: "خطایی از سمت سرور رخ داد",
    btnMoreBlog: "بارگیری بلاگ های بیشتر",
};